/* global zxcvbn */

import React, { useState, useEffect, useRef, FormEvent } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';
import queryString from 'querystring';
import { css, useTheme } from '@emotion/react';
import { BirdiTheme, breakpoints } from '@birdi/theme';
import BirdiLogoSVG from '@birdi/icons/birdi-logo-navy.svg';
// @ts-ignore - JS file without types
import ErrorDisplay from '../../common/ErrorDisplay';
// @ts-ignore - JS file without types
import { updateField, resetPassword } from '../actions';
// @ts-ignore - JS file without types
import EnterCode from '../EnterCode';
// @ts-ignore - JS file without types
import { getZxcvbnResult } from '../resetpasswordutils';
import * as styles from './styles';

interface ResetOrganisationPasswordProps {
  auth: any;
  _updateField: (field: any) => void;
  _resetPassword: (obj: any) => void;
}

const ResetOrganisationPassword: React.FC<ResetOrganisationPasswordProps> = (
  props,
) => {
  const theme = useTheme() as BirdiTheme;
  const location = useLocation();
  const [password, setPassword] = useState('');
  const [zxcvbnResult, setZxcvbnResult] = useState<any>(null);
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    return () => {
      setPassword('');
      props._updateField({
        pendingCode: false,
        code: '',
        error: null,
      });
    };
  }, []);

  const handleSetPassword = (value: string) => {
    const { auth } = props;
    if (typeof (window as any).zxcvbn === 'function') {
      const zxcvbnResultValue = getZxcvbnResult(value, auth.email, auth.name);
      setZxcvbnResult(zxcvbnResultValue);
    }
    setPassword(value);
  };

  const handlePasswordReset = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { auth, _resetPassword } = props;
    const newSearch = location.search.replace('?', '');
    const queryObject = queryString.parse(newSearch);
    const { id, organisationid } = queryObject;
    const code = queryObject.code ? queryObject.code : auth.code;
    if (!formRef.current?.checkValidity()) {
      return formRef.current?.reportValidity();
    }
    return _resetPassword({
      ...(auth.email && { email: auth.email }),
      ...(id && { id }),
      code,
      password,
      ...(organisationid && { organisationId: organisationid }),
    });
  };

  const { auth, _updateField } = props;

  return (
    <>
      {/* Logo - Fixed at top */}
      <div css={styles.logoContainer}>
        <BirdiLogoSVG />
      </div>

      {/* Scrollable Content */}
      <div css={styles.scrollableContent}>
        {/* Header Section */}
        <div css={styles.headerSection}>
          <h1 css={styles.title}>Set up your Birdi account</h1>
          <p css={styles.subtitle}>
            Before you can login, setup a password for your account.
          </p>
        </div>

        {/* Form - EnterCode component handles its own form */}
        <div
          css={css`
            display: flex;
            flex-direction: column;
            gap: 0.25rem;

            @media (min-width: ${breakpoints.s}) {
              gap: 0.5rem;
            }
          `}
        >
          <EnterCode
            form={formRef}
            auth={auth}
            _updateField={_updateField}
            onSubmit={handlePasswordReset}
            setPassword={handleSetPassword}
            password={password}
            zxcvbnResult={zxcvbnResult}
            search={location.search}
            label="Create password"
          />
        </div>
      </div>

      {/* Fixed Footer - Help Link */}
      <div css={styles.fixedFooter}>
        <div css={styles.helpLink}>
          Need help? <a href="mailto:support@birdi.io">Contact support</a>
        </div>
      </div>
    </>
  );
};

export default connect(
  (state: any) => ({
    auth: state.auth,
  }),
  (dispatch: any) => ({
    _updateField: (field: any) => dispatch(updateField(field)),
    _resetPassword: (obj: any) => dispatch(resetPassword(obj)),
  }),
)(ResetOrganisationPassword);
